import React from 'react';
import { X, DollarSign } from 'lucide-react';

const AddFinanceModal = ({
  isOpen,
  onClose,
  financeForm,
  setFinanceForm,
  onSave
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-gray-900 border border-gray-700 rounded-2xl w-full max-w-md" onClick={(e) => e.stopPropagation()}>
        <div className="px-6 py-4 border-b border-gray-700 flex items-center justify-between">
          <h3 className="text-lg font-bold text-white flex items-center gap-2">
            <DollarSign size={20} className="text-green-400" /> Add to Finances
          </h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-800 rounded-full">
            <X size={18} className="text-gray-400" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Description</label>
            <input 
              data-testid="finance-description" 
              value={financeForm.description} 
              onChange={e => setFinanceForm({...financeForm, description: e.target.value})} 
              className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-green-500 focus:outline-none" 
              placeholder="e.g. Software Subscription" 
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Amount ($)</label>
              <input 
                data-testid="finance-amount" 
                type="number" 
                step="0.01" 
                value={financeForm.amount} 
                onChange={e => setFinanceForm({...financeForm, amount: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-green-500 focus:outline-none" 
                placeholder="0.00" 
              />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Type</label>
              <select 
                data-testid="finance-type" 
                value={financeForm.type} 
                onChange={e => setFinanceForm({...financeForm, type: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-green-500 focus:outline-none"
              >
                <option value="expense">Expense</option>
                <option value="income">Income</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Category</label>
              <select 
                data-testid="finance-category" 
                value={financeForm.category} 
                onChange={e => setFinanceForm({...financeForm, category: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-green-500 focus:outline-none"
              >
                <option value="Travel">Travel</option>
                <option value="Food">Food</option>
                <option value="Shopping">Shopping</option>
                <option value="Utilities">Utilities</option>
                <option value="Entertainment">Entertainment</option>
                <option value="Subscription">Subscription</option>
                <option value="Business">Business</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Date</label>
              <input 
                data-testid="finance-date" 
                type="date" 
                value={financeForm.date} 
                onChange={e => setFinanceForm({...financeForm, date: e.target.value})} 
                className="w-full bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 focus:border-green-500 focus:outline-none" 
              />
            </div>
          </div>
          <button 
            data-testid="save-finance-btn" 
            onClick={onSave} 
            className="w-full py-2.5 bg-green-600 hover:bg-green-500 text-white rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
          >
            <DollarSign size={16} /> Add Transaction
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddFinanceModal;
